import styles from "./NaveBarPaginas.module.css";
import logo from "../../Imgs/Logo001.png";
import { Link } from "react-router-dom";
import { FaPowerOff } from "react-icons/fa";
function NaveBarPaginas() {
  return (
    <nav className={styles.navebar}>
      <img src={logo} alt="Geografia em jogos ufpel"></img>

      <Link to="/" className={styles.inicio}>
        <FaPowerOff />
        <p to="/">Inicio</p>
      </Link>
    </nav>
  );
}
export default NaveBarPaginas;
